import React, { useState } from "react";

const AuthContext = React.createContext({
    token: localStorage.getItem("token"),
    isLoggedIn: false,
    clientIdentifier: localStorage.getItem("clientIdentifier"),
    username: localStorage.getItem("username"),
    loginData : localStorage.getItem("loginData"),
    login: (token) => { },
    logout: () => { }
});

export const AuthContextProvider = (props) => {
    const [token, setToken] = useState(localStorage.getItem('token'));
    const [clientIdentifier, setClientIdentifier] = useState(localStorage.getItem('clientIdentifier'));
    const [username, setUsername] = useState(localStorage.getItem('username'));
    const [loginData, setLoginData] = useState(localStorage.getItem('loginData'))

    const userIsLoggedIn = !!token;

    const loginHandler = (token, clientIdentifier, username, loginData) => {
        localStorage.setItem("token", token);
        localStorage.setItem("clientIdentifier", clientIdentifier);
        localStorage.setItem("username", username);
        localStorage.setItem("loginData", JSON.stringify(loginData));
        setToken(token);
        setClientIdentifier(clientIdentifier)
        setUsername(username)
        setLoginData(JSON.stringify(loginData))
    }

    const logoutHandler = () => {
        setToken(null);
        setClientIdentifier(null)
        setLoginData(null)
        localStorage.removeItem("token");
        localStorage.removeItem("clientIdentifier");
        localStorage.removeItem("username");
        localStorage.removeItem("loginData")
    }

    const contextValue = {
        token: token,
        isLoggedIn: userIsLoggedIn,
        clientIdentifier: clientIdentifier,
        username: username,
        loginData : loginData,
        login: loginHandler,
        logout: logoutHandler
    }

    return <AuthContext.Provider value={contextValue}>{props.children}</AuthContext.Provider>
}

export default AuthContext;